export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  actions,
  className = "",
}) {
  return (
    <div className={`section-header section-header-${align} ${className}`.trim()}>
      <div>
        {eyebrow && <span className="ui-badge">{eyebrow}</span>}
        {title && <h2>{title}</h2>}
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="section-header-actions">{actions}</div>}
    </div>
  );
}
